import React, { useState } from 'react';
import Slider from 'react-slick';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteNames } from 'router';
import { useViewport } from 'components/templates/viewportProvider';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { CallToAction } from 'components/atoms/callToAction';
import { PaginationControl } from 'components/molecules/paginationControl';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
import { HTMLView } from 'components/atoms/htmlView';
import artistWebsiteIcon from 'assets/images/Artist-Website_Artists-Arrow_Artists-Arrow.svg';
import { VisitArtistUrl } from 'components/atoms/visitArtistURL';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
//eslint-disable-next-line
import styles from "./styles.scss";

const PastEvents = props => {
  const {
    filteredEvents,
    isFiltered,
    activeFilters,
    pastEventsIntro,
    pastEvents,
    pastEventSection = false,
    cmsDetailData = {},
    showCmsButton,
    hasMore,
    loadingMore,
    pagination,
    activeFilterIds,
    getPastEvents,
  } = props;

  const { height, isMobile } = useViewport();
  const [videoUrl, setVideoUrl] = useState(null);
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showVideoOverlay, setShowVideoOverlay] = useState(false);
  const [showFullBioOverlay, setShowFullBioOverlay] = useState(false);
  if (pastEventsIntro.artist_website_url !== '')
    cmsDetailData.website_url = pastEventsIntro.artist_website_url;

  const getVideoUrl = url => {
    setVideoUrl(url);
  };

  const paginationLength = pastEvents.length;

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };

  const settings = {
    className: 'past-events-slider',
    infinite: false,
    slidesToShow: 1.37,
    slidesToScroll: 1,
    variableWidth: false,
    speed: 1000,
    beforeChange: (current, next) => {
      setActiveSlide(next);
      if (next >= pastEvents.length - 2 && hasMore && !loadingMore) {
        getPastEvents(pagination.page + 1, 25, {
          venueIds: (activeFilterIds && activeFilterIds.venue) || [],
          cityIds: (activeFilterIds && activeFilterIds.city) || [],
          genreIds: (activeFilterIds && activeFilterIds.genre) || [],
          artistIds: (activeFilterIds && activeFilterIds.artist) || [],
        });
      }
    },
    arrows: false,
    draggable: true,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const toggleOverlay = showOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={isFiltered ? filteredEvents : pastEvents}
        theme={'light-theme'}
        type={'past-events'}
        onClosePress={() => setShowOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Music & Events',
            breadcrumbLink: RouteNames.musicEvents,
          },
          {
            breadcrumbName: 'All Past Events',
            breadcrumbLink: '#',
          },
        ]}
        activeFilters={activeFilters}
        headerClass={'header-name'}
      />
    </OverlayPortal>
  ) : null;

  const toggleVideoOverlay = showVideoOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={videoUrl}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'past-event-video'}
        onClosePress={() => setShowVideoOverlay(false)}
        breadcrumbList={[]}
      />
    </OverlayPortal>
  ) : null;

  const toggleFullBioOverlay = showFullBioOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={cmsDetailData}
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'ourDifference'}
        className={'ourHomesOverlay'}
        onClosePress={() => setShowFullBioOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Music & Events',
            breadcrumbLink: RouteNames.musicEvents,
          },
          {
            breadcrumbName: 'Artist Details',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'past-events section-container'} style={{ height }}>
      {!isMobile && pastEventSection && (
        <div className={'open-overlay'}>
          <CallToAction
            mode={'dark'}
            className={'cta-button-item'}
            text={'SEE ALL'}
            onClick={() => setShowOverlay(true)}
          />
        </div>
      )}

      {showCmsButton && (
        <div className={'open-overlay'}>
          <CallToAction
            mode={'light'}
            className={'cta-button-item'}
            text={'FULL BIO'}
            onClick={() => setShowFullBioOverlay(true)}
          />
        </div>
      )}

      <div className={'section-intro'}>
        <h3>{pastEventsIntro.heading}</h3>
        <h1>{pastEventsIntro.subHeading}</h1>
        {pastEventsIntro.artist_website_url && (
          <VisitArtistUrl
            website_url={pastEventsIntro.artist_website_url}
            staticText={pastEventsIntro.artist_website_label}
            icon={artistWebsiteIcon}
          />
        )}
        <HTMLView
          html={pastEventsIntro.paragraph}
          tagName={'p'}
          className={'description'}
        />
        {/* <p>{pastEventsIntro.paragraph}</p> */}
      </div>
      <div className={'past-events-carousel'}>
        {isFiltered && pastEvents.length === 0 ? (
          <div className={'no-events-found'}>
            <h2 className={'no-events-title'}>No Events Found</h2>
            <p className={'no-events-subtitle'}>Try adjusting your filters to discover more events.</p>
          </div>
        ) : pastEvents && pastEvents.length > 0 ? (
          <Slider
            ref={c => setSlider(c)}
            {...settings}
            style={{ height: '100%' }}
          >
            {pastEvents &&
              pastEvents.map((data, idx) => {
                return (
                  <div
                    className={'past-events-card'}
                    key={idx}
                    onClick={() => getVideoUrl(data.videoUrl)}
                  >
                    <div className={'card-image'}>
                      {data.videoUrl ? (
                        <img src={data.videoThumbNail || data.image} alt={''} />
                      ) : (
                        <img src={data.image} alt={''} />
                      )}
                    </div>
                    <div className={'card-data'}>
                      <div className={'left-content'}>
                        {pastEventSection && (
                          <h2 className={'artist-name'}>{data.name}</h2>
                        )}
                        {!pastEventSection && (
                          <div className={'artist-video-data'}>
                            <span className={'video-date'}>{data.date}</span>
                            <h3 className={'video-venue'}>{data.venue}</h3>
                            <h3 className={'video-location'}>
                              {data.location}
                            </h3>
                          </div>
                        )}
                        {data.videoUrl && (
                          <CallToAction
                            text={'WATCH NOW'}
                            onClick={() => setShowVideoOverlay(true)}
                            mode={'transparent'}
                          />
                        )}
                      </div>
                      <div className={'right-content'}>
                        <h3 className={'heading'}>{data.heading}</h3>
                        <HTMLView
                          html={data.description}
                          tagName={'p'}
                          className={'description'}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </Slider>
        ) : (
          <div className={'artist-card-image'}>
            <img src={pastEventsIntro.artist_image} alt={'artist-image'} />
          </div>
        )}
      </div>
      <div className={'section-footer show-explore'}>
        <PaginationControl
          className={'section-footer-item'}
          theme={'light-theme'}
          mode={'slider'}
          currentIndex={activeSlide + 1}
          total={paginationLength}
          onNextClick={next}
          onPreviousClick={previous}
        />
      </div>
      {toggleOverlay}
      {toggleVideoOverlay}
      {toggleFullBioOverlay}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isFiltered: EventSelector.isEventsFiltered(state, 'past'),
    activeFilters: EventSelector.getActiveEventFiltersNames(state),
    filteredEvents: EventSelector.getFilteredEvents(state, 'past'),
    hasMore: EventSelector.hasMorePastEvents(state),
    loadingMore: EventSelector.getPastEventsLoadingMore(state),
    pagination: EventSelector.getPastEventsPagination(state),
    activeFilterIds: EventSelector.getActiveEventFilters(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getPastEvents } = EventActions;
  return bindActionCreators({ getPastEvents }, dispatch);
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PastEvents);

export default withRouter(connectedComponent);
